<template>
    <section class="blog__articles">
        <div class="container">
            
            <div class="row">
                <div class="col-12">
                    <h2 class="title" v-text="title"></h2>
                </div>
            </div>

            <template v-if="loading">
                <loader />
            </template>
            <template v-else>

                <template v-if="!articles.length">
                    <div class="row">
                        <div class="col-12">
                            <h3 class="d-flex justify-content-center align-items-center">
                                Статей нет
                            </h3>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <template v-if="screenWidth <= 768">
                        
                        <div class="row">
                            <div class="col-12">
                                <swiper :options="$options.sliderOptions">

                                    <swiper-slide v-for="article in articles" :key="article.slug">
                                        <article-item :article="article" />
                                    </swiper-slide>

                                </swiper>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                            <slider-pagination 
                                :idPrev="'articles-prev'" :idNext="'articles-next'"
                                :navigationBtn="$options.navigationBtn"
                            />
                            </div>
                        </div>

                    </template>
                    <template v-else>
                        <div class="row blog__articles-grid">
                            <template v-for="article in articles">
                                <div class="col-md-6 col-lg-4" :key="article.slug">
                                    <article-item :article="article" />
                                </div>   
                            </template>
                        </div>
                        <template v-if="page < meta.last_page">
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-center mt-3">
                                        <a href="#" class="btn" @click.prevent="page += 1">
                                            Загрузить ещё {{ loadArticlesCount }} статей
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>

                </template>

            </template>

        </div>
    </section>
</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

import ArticleItem from './Article.vue'
import Loader from '../LoaderBalls.vue'
import SliderPagination from './SliderPagination.vue'
import { eventHub } from './eventHub'

export default {
    name: "BlogArticles",
    components: { ArticleItem, Loader, Swiper, SwiperSlide, SliderPagination },

    props: {
        title: { required: false, type: String, default: 'Статьи' }
    },

    data: () => (
        {
            loading: false,
            articles: [],
            meta: null,
            page: 1,
            screenWidth: 0,
        }
    ),

    navigationBtn: {
      href: '#',
      text: 'Смотреть все'
    },

    sliderOptions: {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: '#articles-next',
        prevEl: '#articles-prev',
     }
    },

    created(){
        this.handleScreenWidth()
        window.addEventListener(
            'resize',
            this.handleScreenWidth
        )
    },
    
    mounted(){
        this.fetchArticles()

        eventHub.$on(
            'update:postLiked', 
            this.handleUpdatePostLike
        );

    },

    destroyed(){
        window.removeEventListener(
            'resize',
            this.handleScreenWidth
        )
    },

    computed: {
        loadArticlesCount(){

            if( this.meta ) {
                if( this.meta.total - this.articles.length > 6 ) return 6
                else return this.meta.total - this.articles.length
            }

            return 0
        }
    },

    methods: {
        handleUpdatePostLike( target ){
            this.articles = this.articles.map(
                it => {
                    if( it.id === target.post_id ) it.follow = target.follow

                    return it
                }
            )
        },
        handleScreenWidth(){
            this.screenWidth = window.innerWidth
        },
        async fetchArticles () {
            if( ! this.articles.length ) this.loading = true
            try{ 

                let { data: { data = [], success = false, meta = null } } = await axios.get('/api/posts', { params: { per_page: 6, page: this.page } } )
                
                if( success ) {
                
                    this.articles = [ ...this.articles, ...data ]
                    this.meta = meta
                    this.loading = false
                    
                }

            } catch ( e ){
                this.loading = false
            }


        }

    },

    watch: {
        page: 'fetchArticles'
    }

}

</script>
